export var source = "query PlansQuery($input: PlansQueryInput) {\n  plans: plansQuery(input: $input) {\n    name\n    priceCents\n    productsPerPeriod\n  }\n}";
export default source;